import React from "react";
import { Link, Redirect, useParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiPhone, mdiWhatsapp } from "@mdi/js";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { getPost, sortedPosts, formatDate, readingMinutes } from "../content/posts";
import { useSite } from "../theme/ThemeProvider";

const BlogPost = () => {
  const { slug } = useParams();
  const site = useSite();
  const post = getPost(slug);
  if (!post) return <Redirect to="/blog" />;
  const related = sortedPosts.filter((p) => p.slug !== slug).slice(0, 4);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.excerpt,
    image: `${site.url}${post.image}`,
    datePublished: post.date,
    dateModified: post.date,
    author: { "@type": "Organization", name: site.name },
    publisher: { "@type": "Organization", name: site.name, url: site.url },
    mainEntityOfPage: `${site.url}/blog/${post.slug}`,
  };

  return (
    <Layout>
      <Seo title={post.title} description={post.excerpt} path={`/blog/${post.slug}`} image={post.image} type="article" jsonLd={jsonLd} />
      <PageHero
        title={post.title}
        crumbs={[{ label: "Blog", to: "/blog" }, { label: post.title }]}
        meta={
          <>
            <span>{formatDate(post.date)}</span>
            <span>·</span>
            <span>{readingMinutes(post.body)} dk okuma</span>
            <span>·</span>
            <span>{site.name}</span>
          </>
        }
      />
      <section className="section">
        <div className="container">
          <div className="post">
            <article>
              <img className="post__cover" src={post.image} alt="" />
              <div className="prose" dangerouslySetInnerHTML={{ __html: post.body }} />
              <div className="post__tags">
                {post.tags.map((t) => (
                  <span className="badge" key={t}>
                    {t}
                  </span>
                ))}
              </div>
            </article>
            <aside className="post__aside">
              <div className="cta-card">
                <h3>Sorunuz mu var?</h3>
                <p>Aracınız için en doğru cevabı ustamızdan alın.</p>
                <div className="cta-card__actions">
                  <a href={`tel:${site.phoneHref}`} className="btn btn--accent">
                    <Icon path={mdiPhone} /> {site.phone}
                  </a>
                  <a href={`https://wa.me/${site.whatsapp}`} target="_blank" rel="noreferrer" className="btn btn--outline-light">
                    <Icon path={mdiWhatsapp} /> WhatsApp
                  </a>
                </div>
              </div>
              <div className="card card__body">
                <h4 style={{ marginBottom: 8 }}>Diğer yazılar</h4>
                {related.map((p) => (
                  <Link className="mini-post" to={`/blog/${p.slug}`} key={p.slug}>
                    <img src={p.image} alt="" loading="lazy" />
                    <div>
                      <strong>{p.title}</strong>
                      <span>{formatDate(p.date)}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </section>
      <CtaBand />
    </Layout>
  );
};

export default BlogPost;
